// Обёртка для страницы раздела, который входит в тариф: без функции вместо страницы показывается
// предложение сменить тариф, а сама страница даже не загружается (и не шлёт запросов).
import { h, defineComponent, defineAsyncComponent, onMounted } from 'vue'
import { useTariffInfoStore } from '../stores/tariffInfo'
import FeatureUpsell from '../components/FeatureUpsell.vue'

export function gate(feature, loader) {
  const Inner = defineAsyncComponent(loader)
  return defineComponent({
    name: 'FeatureGate',
    setup() {
      const tariff = useTariffInfoStore()
      onMounted(() => tariff.load())
      return () => {
        if (!tariff.loaded) return null
        if (!tariff.has(feature)) return h(FeatureUpsell, { feature })
        return h(Inner)
      }
    }
  })
}
